export const driver = {
  list: {
    title: 'Drivers',
    loading: 'Loading drivers...',
    error: 'Failed to load drivers.',
    searchPlaceholder: 'Search by name, email or employee ID…',
    empty: {
      title: 'No drivers yet',
    },
    noResults: {
      title: 'No drivers found',
      description: 'Adjust your search or filters to see results again.',
      reset: 'Reset search and filters',
    },
    columns: {
      firstName: 'First name',
      lastName: 'Last name',
      employeeId: 'Employee ID',
      email: 'Email',
      status: 'Status',
      phone: 'Landline',
      mobile: 'Mobile',
      location: 'Location',
      department: 'Department',
      costCenter: 'Cost center',
      currentAssignment: 'Current assignment',
    },
    result: { singular: 'driver', plural: 'drivers' },
    actions: { add: 'Add Driver' },
  },
  status: { active: 'Active', inactive: 'Inactive' },
  detail: {
    title: 'Driver',
    back: 'All Drivers',
    error: 'Failed to load driver.',
    tabs: {
      details: 'Details',
      assignment: 'Vehicle assignment',
    },
    actions: {
      edit: 'Edit',
      save: 'Save',
      saving: 'Saving…',
      activate: 'Activate driver',
      deactivate: 'Deactivate driver',
    },
    toast: { updated: 'Changes saved', activated: 'Driver activated', deactivated: 'Driver deactivated' },
    unsavedChanges: {
      title: 'Discard your changes?',
      description: 'Your changes to this driver have not been saved.',
      keepEditing: 'Keep editing',
      discard: 'Discard',
    },
    deactivateConfirm: {
      title: 'Deactivate {{name}}?',
      description: 'The driver keeps their records but can no longer be selected anywhere in the product.',
      descriptionWithVehicle:
        '{{name}} currently drives {{vehicle}}. Deactivating ends that assignment and releases the vehicle.',
      // Provisional copy for a redacted vehicle, pending product blessing.
      descriptionWithVehicleRedacted:
        '{{name}} currently drives a vehicle. Deactivating ends that assignment and releases the vehicle.',
      refused: 'This driver still has a vehicle assigned. Have the assignment ended first.',
      cancel: 'Cancel',
      confirm: 'Deactivate',
    },
  },
  assignment: {
    title: 'Current assignment',
    empty: 'No vehicle currently assigned',
    saveFirst: 'Save the driver before assigning a vehicle.',
    assign: 'Assign vehicle',
    end: 'End assignment',
    inactiveReason: 'Inactive drivers cannot be assigned a vehicle.',
    columns: { vehicle: 'Vehicle', date: 'Assignment date' },
    dialog: {
      assign: {
        title: 'Assign a vehicle',
        vehicleLabel: 'Vehicle',
        vehiclePlaceholder: 'Select a vehicle…',
        noVehicleAvailable: 'No unassigned vehicle available',
        startLabel: 'Start date',
        cancel: 'Cancel',
        confirm: 'Assign vehicle',
      },
      end: {
        title: 'End assignment for {{vehicle}}?',
        description: 'The vehicle becomes available for other drivers.',
        unknownVehicle: 'this vehicle',
        cancel: 'Cancel',
        confirm: 'End assignment',
      },
    },
    toast: {
      assigned: 'Vehicle assigned',
      ended: 'Assignment ended',
      failed: 'Assignment could not be saved. Please try again.',
    },
  },
  new: {
    title: 'Add Driver',
    noPermission: 'You do not have permission to create drivers in this tenant.',
    actions: { submit: 'Create Driver', pending: 'Creating…' },
    toast: { created: 'Driver created' },
  },
  form: {
    groups: {
      person: 'Person',
      contact: 'Contact',
      organization: 'Organization',
    },
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      employeeId: 'Employee ID',
      email: 'Email',
      phone: 'Landline',
      mobile: 'Mobile',
      locationId: 'Location',
      department: 'Department',
      costCenter: 'Cost center',
    },
    location: {
      none: 'No location',
    },
    actions: { cancel: 'Cancel' },
    validation: { required: 'Required', email: 'Enter a valid email address' },
  },
  // Unused until a roles-management screen exists; kept as ready copy.
  roles: {
    person: { read: 'Drivers — view person', write: 'Drivers — edit person' },
    contact: { read: 'Drivers — view contact', write: 'Drivers — edit contact' },
    organization: { read: 'Drivers — view organization', write: 'Drivers — edit organization' },
    status: { read: 'Drivers — view status', write: 'Drivers — change status' },
    assignments: { read: 'Drivers — view assignments', write: 'Drivers — change assignments' },
    // Provisional copy, pending product blessing.
    create: 'Drivers — create driver',
  },
};
export type DriverResources = typeof driver;
